import * as React from 'react';
import {NumericFormatter} from '../../../utility/FormatValueUtils';
import {Channel} from '../../../types/Channel';
import {stylesheet} from 'typestyle';
import {MergedBuildingBlockInstructions, NamedDateRangeWithPreviewDateRange, ReportBuildingBlock, TableBuildingBlock} from '../../types/Report';
import TablePreview from '../PaperSheetBlocks/TablePreview';

interface PreviewTableBlockProps {
    targetCurrency?: string;
    buildingBlock: TableBuildingBlock;
    selectedNamedDateRange?: NamedDateRangeWithPreviewDateRange;
    moneyFormatToTargetCurrency: (fractions?: number) => NumericFormatter;
    getFullChannelForChannelName: (channelName: string) => Channel;
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
}

export default function PreviewTableBlock({
    targetCurrency,
    buildingBlock,
    selectedNamedDateRange,
    moneyFormatToTargetCurrency,
    getFullChannelForChannelName,
    getMergedBuildingBlockInstructions,
}: PreviewTableBlockProps) {
    const mergedBuildingBlockInstructions = getMergedBuildingBlockInstructions(buildingBlock);

    const {channels, sortings, activeViews} = mergedBuildingBlockInstructions.tableInstruction
        ? mergedBuildingBlockInstructions.tableInstruction
        : {activeViews: [], channels: [], sortings: []};

    if (channels.length === 1 && sortings.length <= 1 && activeViews.length === 1 && selectedNamedDateRange) {
        return (
            <div className={tableBlockCss.tablePreviewContainer}>
                <TablePreview
                    targetCurrency={targetCurrency}
                    previewModeEnabled={true}
                    columns={buildingBlock.columns}
                    lineLimit={buildingBlock.lineLimit}
                    dateRange={selectedNamedDateRange.previewDateRange}
                    mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                    moneyFormatToTargetCurrency={moneyFormatToTargetCurrency}
                    getFullChannelForChannelName={getFullChannelForChannelName}
                />
            </div>
        );
    }
    return null;
}
const tableBlockCss = stylesheet({
    tablePreviewContainer: {
        position: 'relative',
        minHeight: 300,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PreviewPaperSheetBlocks/PreviewTableBlock.tsx